var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Avanzado")]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Nueva demo")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            label: "Nombre de la razón social de la organización DEMO",
            expanded: "",
          },
        },
        [
          _c("b-input", {
            attrs: { placeholder: "Ingrese aquí el nombre" },
            model: {
              value: _vm.data.razon_social,
              callback: function ($$v) {
                _vm.$set(_vm.data, "razon_social", $$v)
              },
              expression: "data.razon_social",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "message is-dark" }, [
        _c("div", { staticClass: "message-body" }, [
          _c("h1", { staticClass: "title is-3" }, [
            _vm._v(_vm._s(_vm.data.razon_social)),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-right" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            attrs: { disabled: _vm.data.razon_social == "" },
            on: { click: _vm.submit },
          },
          [_vm._v("Activar demo")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Configure los parámetros para iniciar (o reiniciar) una demo en el sistema."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("El manual de la demo lo puede encontrar "),
        _c(
          "a",
          {
            attrs: {
              href: "https://drive.google.com/open?id=1uajiugIhNf5RhnUtKywLFJaDPMzozlbX",
              target: "_blank",
            },
          },
          [_vm._v("haciendo clic aquí")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "table",
      { staticClass: "table is-narrow is-bordered is-fullwidth" },
      [
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { width: "200" } }, [
              _vm._v("\n            Administrador\n          "),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("\n            dmedina\n          ")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { width: "200" } }, [
              _vm._v("\n            Empleador\n          "),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("\n            vprieto\n          ")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { width: "200" } }, [
              _vm._v("\n            Empleados\n          "),
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n            mlozano, adelgado, ocabrera\n          "),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { width: "200" } }, [
              _vm._v("\n            Manual y archivos\n          "),
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://drive.google.com/open?id=1uajiugIhNf5RhnUtKywLFJaDPMzozlbX",
                    target: "_blank",
                  },
                },
                [_vm._v("Clic aquí")]
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }